import React from 'react';
import { Button, Row, Col } from 'seduo-ui';
import { Link } from 'react-router';
import { path } from '../basename';
export default () => (<div>
        <div className="jumbotron-header text-center mb-3">
            <Row>
                <Col>
                    <h1 className="jumbotron-heading display-4">Seduo UI</h1>
                    <p className="lead">UI library based on Reactstrap</p>
                    <p className="mt-9">
                        <Button color="primary" tag={Link} to={path('components/')}>
                            View Components
                        </Button>
                    </p>
                </Col>
            </Row>
        </div>
    </div>);
